<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab type="task" />

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model.trim="filters.userId" placeholder="用户ID" clearable size="mini"
                @keyup.enter.native="handleSearch" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input v-model.trim="filters.taskId" placeholder="任务ID" clearable size="mini"
                @keyup.enter.native="handleSearch" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input v-model.trim="filters.taskName" placeholder="任务名称" clearable size="mini"
                @keyup.enter.native="handleSearch" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.taskBelong" placeholder="任务所属" clearable size="mini">
                <el-option v-for="item in taskBelongOptions" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.taskType" placeholder="任务类型" clearable size="mini">
                <el-option v-for="item in taskTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.taskStatus" placeholder="用户任务状态" clearable size="mini">
                <el-option v-for="item in taskStatusOptions" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-date-picker v-model="filters.receiveRange" type="datetimerange" value-format="timestamp"
              range-separator="至" start-placeholder="任务领取开始时间" end-placeholder="任务领取结束时间"
              size="mini" />
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <el-table :data="tableList" height="calc(100vh - 340px)" size="mini" v-loading="loading">
        <el-table-column prop="userId" label="用户ID" min-width="120" show-overflow-tooltip />
        <el-table-column prop="taskId" label="任务ID" min-width="100" show-overflow-tooltip />
        <el-table-column prop="taskName" label="任务名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="taskBelongDesc" label="任务所属" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.taskBelongDesc || taskBelongMap[scope.row.taskBelong] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="taskTypeDesc" label="任务类型" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.taskTypeDesc || taskTypeMap[scope.row.taskType] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="taskStatusDesc" label="用户任务状态" min-width="120">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusTag(scope.row).type">
              {{
                scope.row.taskStatusDesc ||
                  statusTag(scope.row).text
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="卡券ID" min-width="180">
          <template slot-scope="scope"><coupon-id-cell :items="allCouponIds(scope.row)" @view-all="showAllCouponIds('任务全部卡券ID', $event)" /></template>
        </el-table-column>
        <el-table-column prop="couponAmount" label="卡券金额" min-width="100">
          <template slot-scope="scope">{{ formatValue(allCouponAmount(scope.row)) }}</template>
        </el-table-column>
        <el-table-column label="已领取卡券ID" min-width="190">
          <template slot-scope="scope"><coupon-id-cell :items="receivedCouponIds(scope.row)" @view-all="showAllCouponIds('已领取卡券ID', $event)" /></template>
        </el-table-column>
        <el-table-column label="已领取卡券金额" min-width="130">
          <template slot-scope="scope">{{ formatValue(receivedCouponAmount(scope.row)) }}</template>
        </el-table-column>
        <el-table-column prop="receiveTime" label="任务领取时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.receiveTime) }}</template>
        </el-table-column>
        <el-table-column prop="completeTime" label="任务完成时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.completeTime) }}</template>
        </el-table-column>
        <el-table-column prop="couponReceiveTime" label="卡券领取时间" min-width="160">
          <template slot-scope="scope">{{ formatTime(couponReceiveTime(scope.row)) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <!-- 撤回奖励：待领取奖励时展示，本期不做 -->
            <el-button
              v-if="canOnline(scope.row)"
              type="text"
              size="mini"
              @click="handleOnline(scope.row)"
            >上线</el-button>
            <el-button
              v-if="canOffline(scope.row)"
              type="text"
              size="mini"
              @click="handleOffline(scope.row)"
            >下线</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pag">
        <pagination :size="pagination.size" :total="totalCount" :page="pagination.page"
          @pageChanged="pageChanged" />
      </div>
      <el-dialog :title="couponDialogTitle" :visible.sync="couponDialogVisible" width="460px" append-to-body>
        <div v-for="(item, index) in couponDialogItems" :key="`${item}-${index}`" class="coupon-dialog-item">{{ item }}</div>
        <div slot="footer"><el-button size="small" type="primary" @click="couponDialogVisible = false">确认</el-button></div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from 'components/pagination'
import Tab from '../components/Tab'
import CouponIdCell from './components/CouponIdCell.vue'
import api from './api'
import {
  PAGINATION,
  TASK_BELONG_OPTIONS,
  TASK_BELONG_MAP,
  TASK_TYPE_OPTIONS,
  TASK_TYPE_MAP,
  TASK_STATUS_OPTIONS,
  TASK_STATUS_MAP,
  TASK_STATUS_TAG,
} from './constants'

function createFilters() {
  return {
    userId: '',
    taskId: '',
    taskName: '',
    taskBelong: '',
    taskType: '',
    taskStatus: '',
    receiveRange: [],
  }
}

export default {
  name: 'WelfareTaskRecord',
  components: { Pagination, Tab, CouponIdCell },
  data() {
    return {
      loading: false,
      filters: createFilters(),
      taskBelongOptions: TASK_BELONG_OPTIONS,
      taskBelongMap: TASK_BELONG_MAP,
      taskTypeOptions: TASK_TYPE_OPTIONS,
      taskTypeMap: TASK_TYPE_MAP,
      taskStatusOptions: TASK_STATUS_OPTIONS,
      taskStatusMap: TASK_STATUS_MAP,
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      couponDialogVisible: false,
      couponDialogTitle: '',
      couponDialogItems: [],
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    formatValue(value) {
      return value === null || value === undefined || value === '' ? '--' : value
    },
    normalizeCouponIds(value) {
      if (Array.isArray(value)) return value.map((item) => typeof item === 'object' ? (item.couponNo || item.couponId || item.id) : item).filter(Boolean).map(String)
      if (value === null || value === undefined || value === '') return []
      return String(value).split(/[,，\s]+/).filter(Boolean)
    },
    allCouponIds(row) {
      return this.normalizeCouponIds(row.coupons || row.couponIds || row.couponNos || row.rewardCouponIds || row.rewardTiers || row.couponNo)
    },
    receivedCouponIds(row) {
      return this.normalizeCouponIds(row.receivedCoupons || row.receivedCouponIds || row.receivedCouponNos || row.receiveCouponIds || row.receiveCouponNos || row.claimedCouponIds || row.claimedCouponNos)
    },
    allCouponAmount(row) {
      if (row.couponAmount != null) return row.couponAmount
      return row.couponAmountTotal != null ? row.couponAmountTotal : row.totalCouponAmount
    },
    receivedCouponAmount(row) {
      const candidates = [row.receivedCouponAmount, row.receivedCouponAmountTotal, row.receiveCouponAmount, row.claimedCouponAmount]
      const value = candidates.find((item) => item !== null && item !== undefined && item !== '')
      return value === undefined ? null : value
    },
    couponReceiveTime(row) {
      const direct = row.couponReceiveTime || row.couponReceiveAt || row.lastCouponReceiveTime
      if (direct) return direct
      const coupons = Array.isArray(row.receivedCoupons) && row.receivedCoupons.length
        ? row.receivedCoupons : (Array.isArray(row.coupons) ? row.coupons : [])
      const times = coupons.map((item) => Number(item && item.receiveTime)).filter((item) => item > 0)
      return times.length ? Math.max(...times) : null
    },
    showAllCouponIds(title, items) {
      this.couponDialogTitle = title
      this.couponDialogItems = items
      this.couponDialogVisible = true
    },
    formatTime(value) {
      if (value === null || value === undefined || value === '') return '--'
      let timestamp = value
      if (typeof value === 'object') timestamp = value.timestamp || value.time || value.value
      if (/^\d+$/.test(String(timestamp))) {
        timestamp = Number(timestamp)
        if (timestamp > 0 && timestamp < 100000000000) timestamp *= 1000
      }
      const date = moment(timestamp)
      return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : '--'
    },
    statusTag(row) {
      const status = this.getUserTaskStatus(row)
      return (
        TASK_STATUS_TAG[status] || {
          text: row.taskStatusDesc || TASK_STATUS_MAP[status] || status || '-',
          type: 'info',
        }
      )
    },
    /** 用户任务状态 */
    getUserTaskStatus(row) {
      if (!row) return ''
      if (row.userTaskStatus != null && row.userTaskStatus !== '') {
        return row.userTaskStatus
      }
      return row.taskStatus || ''
    },
    /** 任务（配置）状态：未开始/进行中/已过期/已下线 */
    getConfigTaskStatus(row) {
      if (!row) return ''
      const candidates = [
        row.taskConfigStatus,
        row.configTaskStatus,
        row.taskManageStatus,
        row.manageTaskStatus,
        row.parentTaskStatus,
        row.welfareTaskStatus,
      ]
      for (let i = 0; i < candidates.length; i += 1) {
        if (candidates[i] != null && candidates[i] !== '') {
          return candidates[i]
        }
      }
      // 若单独返回了 userTaskStatus，则 taskStatus 可能是配置任务状态
      if (row.userTaskStatus != null && row.userTaskStatus !== '') {
        return row.taskStatus || ''
      }
      return ''
    },
    /** 任务状态是否为进行中（有返回则以返回为准；未返回时不阻断，兼容旧字段） */
    isConfigTaskInProgress(row) {
      const status = this.getConfigTaskStatus(row)
      if (!status) return true
      return status === 'IN_PROGRESS'
    },
    /** 上线：用户任务已下线 且 任务状态进行中 */
    canOnline(row) {
      return row && row.operationType === 'ONLINE' && this.isConfigTaskInProgress(row)
    },
    /** 下线：用户任务非已下线 且 任务状态进行中 */
    canOffline(row) {
      return row && row.operationType === 'OFFLINE' && this.isConfigTaskInProgress(row)
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.filters = createFilters()
      this.pagination = { ...PAGINATION }
      this.fetchList()
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size }
      this.fetchList()
    },
    buildQuery() {
      const query = { page: this.pagination.page, size: this.pagination.size }
      const { userId, taskId, taskName, taskBelong, taskType, taskStatus, receiveRange } = this.filters
      if (userId) query.userId = userId
      if (taskId) query.taskId = taskId
      if (taskName) query.taskName = taskName
      if (taskBelong) query.taskBelong = taskBelong
      if (taskType) query.taskType = taskType
      if (taskStatus) query.taskStatus = taskStatus
      if (receiveRange && receiveRange.length === 2) {
        query.receiveStartTime = receiveRange[0]
        query.receiveEndTime = receiveRange[1]
      }
      return query
    },
    fetchList() {
      this.loading = true
      api
        .list(this.buildQuery())
        .then((res) => {
          if (res && res.code === 0) {
            const data = res.data || {}
            this.tableList = data.items || data.records || data.list || []
            this.totalCount =
              data.total != null ? data.total : data.totalCount != null ? data.totalCount : 0
          } else {
            this.tableList = []
            this.totalCount = 0
            this.$message.error((res && (res.msg || res.message)) || '查询失败')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOnline(row) {
      api
        .updateStatus({ userTaskId: row.userTaskId, action: 'ONLINE' })
        .then((res) => {
          if (res && res.code === 0) {
            this.$message.success('上线成功')
            this.fetchList()
          } else {
            this.$message.error((res && res.msg) || '上线失败')
          }
        })
        .catch(() => {
          this.$message.error('上线失败')
        })
    },
    handleOffline(row) {
      this.$confirm('是否确认下线，下线后该用户的任务列表不再展示该任务', '提示', {
        type: 'warning',
        distinguishCancelAndClose: true,
      })
        .then(() => api.updateStatus({ userTaskId: row.userTaskId, action: 'OFFLINE' }))
        .then((res) => {
          if (res && res.code === 0) {
            this.$message.success('下线成功')
            this.fetchList()
          } else {
            this.$message.error((res && res.msg) || '下线失败')
          }
        })
        .catch((err) => {
          // 取消/关闭弹框不提示失败
          if (err === 'cancel' || err === 'close') return
          this.$message.error('下线失败')
        })
    },
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
</style>
